import { useSerialIds } from "highcharts";
import React, { useEffect, useState, useContext } from "react";
import appFetch from "../appFetch";
import apiEndpoints from "../apiEndpoints";
import styled from "styled-components";
import { Formik, Form as FormikForm, Field, ErrorMessage } from "formik";
import { LockClosedIcon, UserIcon, MailIcon } from "@heroicons/react/solid";
import Spinner from "../loaders/Spinner";
import * as Yup from "yup";

import doubleBubbleBackground from "../assets/images/double-bubble-outline.png";
import LoginLogo from "../assets/images/login-logo.png";
import ReactJson from "react-json-view";
import { setToLS } from "../util/storage";
import { Link, useHistory } from "react-router-dom";
import toast from "react-hot-toast";
import AppContext from "../contexts/AppContext";
import PhoneNumber from "../components/PhoneNumber";
import WithThemeWrapper from "../theme/WithThemeWrapper";
import renderComponent from "../renderComponent";

const formData = {
  name: "Booking",
  subcomponents: [
    {
      type: "SignUpFormStepper1",
      target_id: 89730,
      button_action: "SAVE",
      submit_action: "BOOK NOW",
      button_otp: null,
      button_hide: "false",
      enableImport: null,
      enableModal: null,
      // excel_template: [
      //   {
      //     name: "ORGANIZATION_NAME",
      //     column: "NAME",
      //     property: "",
      //     id: "false",
      //     comp: "true",
      //     dup: "true",
      //   },
      // ],
      excel_template: null,
      name: "Booking",
      nextButtonAction: null,
      options: null,
      schema: [
        {
          name: "",
          type: "Form1",
          useCart: "false",
          options: [
            {
              target_id: 19500250,
              target: "label",
              name: "title",
              type: "label",
              label: "Company Details",
            },
            {
              target_id: 19500251,
              target: "text",
              name: "company_name",
              type: "text",
              label: "Company Name",
              root_1: "_SETUP",
              root_2: "NAME",
              edit: "NAME",
              validation: {
                required: true,
              },
            },
            {
              target_id: 19500252,
              target: "text",
              name: "company_url",
              type: "text",
              label: "Url",
              root_1: "_SETUP",
              root_2: "ATTRIBUTE",
              root_3: "url",
              edit: "URL",
              response: "json",
              validation: {
                required: true,
              },
            },
          ],
        },
        {
          name: "",
          type: "Form1",
          useCart: "false",
          options: [
            {
              target_id: 19500253,
              target: "label",
              name: "title",
              type: "label",
              label: "Contact Details",
            },
            {
              target_id: 19500254,
              target: "text",
              name: "first_name",
              type: "text",
              label: "First Name",
              root_1: "_SETUP",
              root_2: "ATTRIBUTE",
              root_3: "first_name",
              edit: "FIRST_NAME",
              response: "json",
              validation: {
                required: true,
              },
            },
            {
              target_id: 19500256,
              target: "email",
              name: "user_email",
              type: "email",
              label: "Email",
              root_1: "_SETUP",
              root_2: "ATTRIBUTE",
              root_3: "email",
              edit: "EMAIL",
              response: "json",
              validation: {
                required: true,
              },
            },
            {
              target_id: 19500257,
              target: "phonenumber",
              name: "user_phone_number",
              type: "phonenumber",
              label: "Phone Number",
              root_1: "_SETUP",
              root_2: "ATTRIBUTE",
              root_3: "phone_number",
              edit: "PHONE_NUMBER",
              response: "json",
              validation: {
                required: true,
              },
            },
          ],
        },
        {
          name: "",
          type: "Form1",
          useCart: "false",
          options: [
            {
              target_id: 19500258,
              target: "label",
              name: "title",
              type: "label",
              label: "Other Details",
            },
            {
              target_id: 19500259,
              target: "checkbox",
              name: "campus",
              type: "checkbox",
              label: "Which campus are wishing to book?",
              root_1: "_SETUP",
              root_2: "RELATIONSHIP",
              root_3: "campus",
              edit: "CAMPUS",
              data: "CAMPUS",
              response: "array",
              validation: {
                required: true,
              },
            },
            {
              target_id: 19500260,
              target: "select",
              name: "advertising",
              type: "select",
              label: "What advertising opportunity are you interested in?",
              root_1: "_SETUP",
              root_2: "ATTRIBUTE",
              root_3: "advertising_id",
              edit: "ADVERTISING_ID",
              data: "CAMPUS",
              response: "json",
              validation: {
                required: true,
              },
            },
            {
              target_id: 19500261,
              target: "upload",
              name: "upload",
              type: "upload",
              label: "Please upload your art work",
              root_1: "_SETUP",
              root_2: "JTABLE",
              edit: "ATTACHMENT",
              preview_section: "uploads",
              response: "array",
              validation: {
                required: true,
              },
            },
          ],
        },
      ],
      required: true,
      submit: {
        subcomponents: ["Save"],
      },
      subcomponents: ["Save"],
      showPreview: null,
      target_type: null,
      useCart: null,
    },
    {
      type: "SavedRecordList1",
      button_action: "SAVE",
      button_hide: "false",
      button_otp: null,
      enableImport: null,
      enableModal: null,
      excel_template: null,
      name: "Booking",
      nextButtonAction: null,
      options: [
        {
          Title: "BOOKING",
          grid: [],
          gridtype: "horizontal",
          pages: 0,
          records_per_page: 40,
          target_id: 89730,
          target_type: "RECORD",
        },
      ],
      preview: null,
      schema: null,
      showPreview: null,
      target_id: 91399,
      target_type: "RECORD",
    },
  ],
  ignoreButton: true,
  type: "GridAndFormStepperWrapper1",
};

const LoginContainer = styled.div`
  background: #ffffff;
`;

const LoginArea = styled.div`
  &:before,
  &:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    z-index: -2;
  }
  &:before {
    background: #fdf9eb;
  }
  &:after {
    background: url(${doubleBubbleBackground});
    background-blend-mode: multiply;
    opacity: 0.25;
    z-index: -1;
  }
`;

function BookPage({ theme, subs }) {
  const [processing, setProcessing] = useState(false);
  const history = useHistory();
  const { context, setContext } = useContext(AppContext);
  let token = localStorage.getItem("token") ?? "";

  const logo = (theme?.logo || [])[0];

  console.log("what is the current Token", token);
  console.log("the formData", formData);

  const postData = (values) =>
    new Promise((resolve, reject) => {
      setProcessing(true);
      let { userName } = values;
      userName = userName.includes("@")
        ? userName
        : Yup.string().appendCountryCode("+234").cast(userName);
      appFetch
        .post(`${apiEndpoints.login}?subs=${subs}`, {
          body: JSON.stringify({ ...values, userName }),
        })
        .then((res) => {
          console.log("value of response is", res);
          resolve(res);
        })
        .catch((err) => reject(err))
        .finally(() => setProcessing(false));
    });

  const logout = () => {
    setProcessing(true);
    appFetch
      .get(apiEndpoints.logout)
      .then((res) => {
        //const loginUrl = getFromLS("loginUrl");
        if (res?.ERROR_MESSAGE === "SUCCESS") {
          localStorage.clear();
          let pathName = window.location.pathname.slice(1).split("/")[0];
          // window.location = `/${pathName}/login`
          history.push(`/${pathName}/login`);
        }
      })
      .catch((err) => console.log(err))
      .finally(() => setProcessing(false));
  };

  return (
    <LoginArea className="min-h-screen h-full flex flex-col items-center justify-center">
      <div className="max-w-lg w-full space-y-8 -mt-5 px-4 ">
        <div>
          <img className="mx-auto h-12 w-auto" src={logo} alt={theme?.name} />
          {/* <h2 className="mt-2 text-center text-2xl font-extrabold text-custom-black-1000">Admin Portal</h2> */}
        </div>
        <LoginContainer className="rounded-lg shadow pt-8 pb-4 px-4 sm:px-6 lg:px-6 h-8/10">
          <h2 className="text-center text-2xl font-medium text-custom-black-100">
            Booking Form
          </h2>

          <p className="mt-2 text-center text-xs">
            <a
              href="#"
              className="font-normal text-custom-gray-200 hover:text-gray-300"
            >
              Book from our array of advertisement services such as Welcome
              Fair, Digital Media and On-Campus Activations
            </a>
          </p>

          <div className="max-h-[400px] md:max-h-[600px] ">
            {renderComponent(formData)}
          </div>

          <div className="flex items-center justify-center">
            <div className="text-sm text-custom-gray-200">
              Return to
              {/* <Link
                to="login"
                className="font-medium cursor-pointer"
                style={{ color: theme?.colors?.primary }}
              >
                &nbsp;Login
              </Link> */}
              <a
                onClick={logout}
                role="button"
                className="font-medium cursor-pointer"
                style={{ color: theme?.colors?.primary }}
              >
                &nbsp;Login
              </a>
            </div>
          </div>
        </LoginContainer>
      </div>
    </LoginArea>
  );
}

export default WithThemeWrapper(BookPage);
